import http from '@/api/Http'

export default{
    async menuList(providerId, serviceType,serviceFlag, clinicType, idno, fav){
        return http.post(`/api/admin/menuSettingSelect`,{ providerId, serviceType, serviceFlag, clinicType, idno, fav })
    },
    async providerGetting(providerId){
        return http.post(`/api/admin/providerGetting`,{ providerId })
    },
    async providerSetting(providerId, adminsetting){
        return http.post(`/api/admin/providerSetting`,{ providerId, adminsetting })
    },
    async selectProviderInfo(providerId){
        return http.post(`/api/admin/selectProviderInfo`,{ providerId })
    },
    async selectProviderAll(hosp){
        return http.post(`/api/admin/selectProviderAll`,{hosp })
    },
    async selectProviderByUrl(url, pvid){
        return http.post(`/api/admin/selectProviderByUrl`,{ url, pvid })
    },    
    async getHoursData(providerId, item){
        return http.post(`/api/admin/getHoursData`,{ providerId, item })
    },
    async getManagerInfo(providerId, jobs, item){
        return http.post(`/api/admin/getManagerInfo`,{ providerId, jobs, item })
    },
    async getLocationInfo(providerId){
        return http.post(`/api/admin/getLocationInfo`,{ providerId })
    },
    async imgUpload(file){
        return http.post('/api/admin/imgUpload', file , { headers: { 'Content-Type': 'multipart/form-data' }})
    },
    async updateText(providerId, type, text){
        return http.post('/api/admin/updateText', { providerId, type, text })
    },
    async updateHtml(providerId, type, html){
        return http.post('/api/admin/updateHtml', { providerId, type, html })
    },
    async providerInfo(providerId){
        return http.post('/api/admin/providerInfo', { providerId })
    },
    async providerHtml(providerId, mddt, item){
        return http.post('/api/admin/providerHtml', { providerId , mddt, item})
    },
    async providerHtmlList(providerId, mddt, item){
        return http.post('/api/admin/providerHtmlList', { providerId , mddt, item})
    },    
    async infoDownload(providerId){
        return http.post('/api/admin/infoDownload', { providerId })
    },
    async listindex(providerId, tName, afterIndex, uniqueIndex){
        return http.post('/api/admin/listindex', { providerId, tName, afterIndex, uniqueIndex })
    }, 
    async hospitalsettinglistdelete(providerId, tName, uniqueIndex){
        return http.post('/api/admin/hospitalsettinglistdelete', { providerId, tName, uniqueIndex })
    },
    async listRefresh(providerId, serviceName, category1, category2){
        return http.post('/api/admin/listRefresh', { providerId, serviceName, category1, category2 })
    },
    async hospitalsettinglistinsert(providerId, insertValue){
        return http.post('/api/admin/hospitalsettinglistinsert', { providerId, insertValue })
    }, 
    async floorAdd(file){
        return http.post('/api/admin/flooradd', file , { headers: { 'Content-Type': 'multipart/form-data' }})
    },
    async floorGuide(providerId){
        return http.post('/api/admin/floorGuide', { providerId })
    },
    async floorGuideDelete(providerId, uniqueIndex){
        return http.post('/api/admin/floorGuideDelete', { providerId, uniqueIndex })
    },
    async termsHtml(providerId, flag){
        return http.post('/api/admin/termsHtml', { providerId, flag })
    },
    async updateTerms(providerId, flag, html){
        return http.post('/api/admin/updateTerms', { providerId, flag, html })
    },
    async insertTerms(providerId, flag, html){
        return http.post('/api/admin/insertTerms', { providerId, flag, html })
    },
    async providerInfoChange(providerId, serviceName, value){
        return http.post('/api/admin/providerInfoChange', { providerId, serviceName, value })
    },
    async getDoctorListData(providerId, clinicId, work){
        return http.post('/api/admin/getDoctorListData', { providerId, clinicId, work })
    },
    async doctorProfileUpload(file){
        return http.post('/api/admin/doctorProfileUpload', file , { headers: { 'Content-Type': 'multipart/form-data' }})
    },
    async doctorWorkChange(providerId, doctorId, work){
        return http.post('/api/admin/doctorWorkChange', { providerId, doctorId, work })
    },
    async doctorCareerInsert(providerId, career){
        return http.post('/api/admin/doctorCareerInsert', { providerId, career })
    },
    async getDoctorInfoFlag(providerId){
        return http.post('/api/admin/getDoctorInfoFlag', { providerId })
    },
    async setFavourite(providerId, menu, idno, favourite){
        return http.post(`/api/admin/setFavourite`,{ providerId, menu, idno, favourite })
    }, 
    async privateMenu(providerId, idno, menu){
        return http.post(`/api/admin/privateMenu`,{ providerId, idno, menu })
    },
    async getCbsdData(pvid, jobs, item){
        return http.post(`/api/admin/getCbsdData`,{ pvid, jobs, item })
    },
    async moreMenuSelect(pvid, idno){
        return http.post(`/api/admin/moreMenuSelect`,{ pvid, idno})
    }, 
    async getInitAdminData(pvid, kind){
        return http.post(`/api/admin/getInitAdminData`,{ pvid, kind})
    },
    async getFileList(pvid, kind){
        return http.post(`/api/admin/getFileList`,{ pvid, kind})
    },
    async getConveList(pvid, jobs, item){
        return http.post(`/api/admin/getConveList`,{ pvid, jobs, item })
    },    
    
}
